import React from 'react'
import Icons from '../../../../config/images';
import './whyChoose.css';

const WhyChooseSection = () => {
    const features = [
      {
        icons: Icons.creativeIcon,
        title: "Creative Excellence",
        description:
          "We bring a unique blend of creativity and technical expertise to every project.",
      },
      {
        icons: Icons.customerIcon,
        title: "Customer-Centric Approach",
        description: "Your goals are at the heart of everything we do.",
      },
      {
        icons: Icons.solutionIcon,
        title: "End-to-End Solutions",
        description: "From design to development, we handle it all.",
      },
      {
        icons: Icons.staticsIcon,
        title: "Proven Track Record",
        description: "A portfolio of successful projects across industries.",
      },
    ];
  
    return (
      <section className="why-choose-us-main-container-page-style">
        <h2>Why Choose Us?</h2>
        <span className="light-sub-text-style">What Sets Us Apart</span>
        <div className="why-choose-us-features-grid-style">
          {features?.map((feature, index) => (
            <div key={index} className="why-choose-us-feature-view">
              <p className="why-choose-feature-title-style">{feature.title}</p>
              <img
                src={feature.icons}
                alt="icons"
                className="why-choose-icon-style"
              />
              <p className="why-choose-feature-description-style">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </section>
    );
  };

export default WhyChooseSection
